import script from "./dummyData10.vue?vue&type=script&lang=js"
export * from "./dummyData10.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__